<template>

    <main class="temoignages-body-template">
        <article>
            <section class="text-right">
                <figure>
                    <img class="picture" v-if="item.picture" :src="require('../../assets/' + item.picture)" alt="">
                    <figcaption>
                        <p :class="item.color">BAPTISTE BAUDET</p>
                        <p class="green">Chef d’entreprise à <br />Saint-Rémy-Lès-Chevreuse (78)</p>
                    </figcaption>
                </figure>
                <p class="number" :class="item.color">
                    250 000
                </p>

                <p class="green uppercase semiBold">
                   clients qui ont souscrit à la nouvelle offre santé en Hongrie
                </p>



                <img class="icono w300" :src="require('../../assets/t4.jpg')">
                <p class="label green">
                   RELAIMOI
                </p>

                <p class="green uppercase semiBold">
                    Une offre unique qui permet de partager ses garanties d'assistance santé avec ses proches.

                </p>
				<iframe width="560" height="200" src="https://www.youtube.com/embed/yGSQ2BebijM" frameborder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>

                <p class="label green">
                    CONTRAT SUR MESURE
                </p>

                <p class="green uppercase semiBold">
                    Une garantie dédiée proposée en cas de « maladie redoutée » par Gan Eurocourtage.
                </p>

            </section>

            <section>
                <svg class="quote" :class="item.color" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59.8 42.61">
                    <path d="M59.8,0H45.59C39,11,34.91,18,33.43,20.83a17.92,17.92,0,0,0-2.17,8.26c0,7.57,6.36,13.52,14.34,13.52s14.2-6,14.2-13.52c0-5.28-2.7-9.2-8.11-11.5ZM28.55,0H14.21C7.57,11.09,3.65,18.13,2.16,21A17.49,17.49,0,0,0,0,29.09c0,7.57,6.22,13.52,14.2,13.52s14.2-6,14.2-13.52c0-5.28-2.7-9.2-8.11-11.5Z"/>
                </svg>
                <h2>Le soutien de Groupama au réseau Sévéane est un gage de solidité, de sérieux et de qualité.</h2>
                <h1>
                    <span>Agir aux côtés</span>
                    <span>BAPTISTE ET TOUS</span>
                    <span>nos <em style="color: #d95c74">PARTENAIRES POUR</em></span>
                    <span><em style="color: #d95c74">OFFRIR UNE MEILLEURE</em></span>
                    <span><em style="color: #d95c74">PROTECTION SANTÉ</em></span>
                </h1>

                <!--<h3>
                    à la tête d'une exploitation<br>
                    de 350 HA, en blé, colza et orge
                </h3>-->

                <p>
                    Baptiste est opticien depuis 26 ans. Il a exercé dans plusieurs grandes enseignes spécialisées. Depuis une quinzaine d’années, il est à son compte à Saint-Rémy-Lès-Chevreuse, en région parisienne. En 2016, il rejoint le réseau <span class="marker" :class="item.color">Sévéane</span>, la plateforme de santé dédiée à l'amélioration des services associés à la complémentaire santé Groupama et à ses 6 millions de bénéficiaires. Un accord de partenariat entre Groupama et PRO BTP, le groupe de protection sociale du Bâtiment et des Travaux publics, est à l’origine de cette initiative et cette extension de services.
                    <br><br>
                    Cette adhésion à Sevéane lui apporte un flux de clients supplémentaire et lui permet aujourd’hui de travailler avec un nombre plus important de verriers afin de répondre aux demandes croissantes des assurés pour s’équiper à moindre coût.<br><br>
                    Dans le domaine de l’optique, particulièrement, les restes à charge sont souvent importants pour les assurés. Dans ce contexte, les mutuelles et complémentaires santé ont mis en place des partenariats avec des réseaux de professionnels de santé pour garantir à leurs clients des soins de qualité au juste prix.<br><br>
                    «&nbsp;Au quotidien, la gestion est très simple. Toutes les informations sont saisies sur la plateforme et la réponse sur le reste à charge est immédiate !&nbsp;»
                    <br><br>
                    Pour Baptiste, «&nbsp;Groupama est un groupe reconnu et attractif sur son secteur dont le soutien au réseau Sévéane est gage supplémentaire de solidité, de sérieux, de qualité et de proximité relationnelle pour les professionnels<br> et les assurés&nbsp;».<br><br>
                    Groupama, Sévéane et les membres de son réseau sont mobilisés autour du même objectif et partagent le même engagement : être au plus proche et satisfaire les besoins de leurs clients.

                </p>

                <a href="" class="link">
                    <svg class="link-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 250 324">
                        <path d="M239,260v56a7.89,7.89,0,0,1-8,8H40A40.12,40.12,0,0,1,0,284V40A40.12,40.12,0,0,1,40,0H242c4,0,8,4,8,8V252a7.89,7.89,0,0,1-8,8Zm-16,16V260H40a23.69,23.69,0,0,0-24,24c0,14,10,24,24,24H223V292H37V276Zm11-31V16H40C26,16,16,26,16,40V253c7-5,14-8,24-8Z"/>
                        <path d="M197,64v61H52V64ZM183,78H67v33H183Z"/>
                    </svg>
                    <div class="link-content">
                        <p>Retrouvez tous les faits qui ont marqué notre année</p>
                        <p><span>Télécharger</span> le rapport annuel</p>
                    </div>
                </a>

            </section>
        </article>
    </main>


</template>

<script>

    export default {
        name: "TemoignageBody",
        props: ['item'],
        mounted() {

            window.removeEventListener('scroll', this.scroll)
            window.addEventListener('scroll', this.scroll)

        },
        methods: {
            scroll() {
                if(!document.querySelector('.temoignages-item-bar.active'))
                    return;

                if (this.isInViewport(document.querySelector('.temoignages-item-bar.active')))
                    document.querySelector('.temoignages-item-bar.active + .temoignages-item-content .close').style.opacity = 0;
                else
                    document.querySelector('.temoignages-item-bar.active + .temoignages-item-content .close').style.opacity = 1;
            },
            isInViewport(elem) {
                let bounding = elem.getBoundingClientRect();
                return (
                    bounding.top >= -document.querySelector('.temoignages-item-bar.active').clientHeight &&
                    bounding.left >= 0 &&
                    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            }
        }
    }
</script>
